module.exports = __webpack_public_path__ + "assets/devices/MC-303-10173a128019a605df107eb73402ff09.svg";